import { render, staticRenderFns } from "./PayrollManagerPage.vue?vue&type=template&id=51ca1d7f&scoped=true"
import script from "./PayrollManagerPage.vue?vue&type=script&lang=js"
export * from "./PayrollManagerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ca1d7f",
  null
  
)

export default component.exports